import {Falsy} from 'quickstart/types'
import {markdown} from 'quickstart/utils/markdown'
import * as R from 'rambdax'
import {useMemo} from 'react'
import {useEqualBy} from '.'

export function useMarkdown(
  source: string | Falsy,
  _options?: Parameters<typeof markdown>[1],
): string | null {
  const options = useEqualBy(R.equals, _options)
  return useMemo(
    () => (source ? markdown(source, options) : null),
    [source, options],
  )
}
